// bu sahifada firebase bilan boglanishimizga yordamchi bo'ladigan Keylar berilgan
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAd4MG52UGCNBaNyZH78qHacnfeNFNVgCU",
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
 
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db, app };
